import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import Vue from 'vue'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
